import _ from 'lodash';
import policiesMessages from '../../Policies/Policies.messages';
import messages from './PolicyLanding.messages';

export default class LandingUtil {
    constructor(viewModelService, translator) {
        this.periodStatusCode = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.PolicyPeriodStatus');
        this.policyLineCode = viewModelService.productMetadata.get('pc').types.getTypelist('typekey.PolicyLine');
        this.translator = translator;

        this.policyCountInformation = {
            Policies: 0,
            Quotes: 0,
            Renewal: 0,
            Change: 0,
            Cancellation: 0,
        };

        this.billingStatusFilter = {
            displayKey: policiesMessages.billingStatus,
            displayValue: '',
            options: [
                {
                    code: 'inGoodStanding',
                    displayKey: policiesMessages.inGoodStanding,
                    displayValue: '',
                    selected: true,
                },
                {
                    code: 'delinquent',
                    displayKey: policiesMessages.delinquent,
                    displayValue: '',
                    selected: true,
                },
            ],
        };
        this.policyStatusFilter = {
            displayKey: policiesMessages.status,
            displayValue: '',
            options: [],
        };

        this.renewalStatusFilter = {
            displayKey: policiesMessages.status,
            displayValue: '',
            options: [],
        };

        this.quoteStatusFilter = {
            displayKey: policiesMessages.status,
            displayValue: '',
            options: [],
        };

        this.policyChangeStatusFilter = {
            displayKey: policiesMessages.status,
            displayValue: '',
            options: [],
        };

        this.cancellationStatusFilter = {
            displayKey: policiesMessages.status,
            displayValue: '',
            options: [],
        };

        this.policyFilter = {
            displayKey: policiesMessages.policies,
            displayValue: 'Policies',
            filters: [this.billingStatusFilter, this.policyStatusFilter],
        };
        this.policyLinesFilter = {
            displayKey: messages.policylandingPolicyLine,
            displayValue: '',
            options: [],
        };
        this.customLobFilter = {
            lobFilter: this.policyLinesFilter,
            filters: this.policyFilter,
        };
        this.quoteFilter = {
            displayKey: policiesMessages.policyLandingQuotes,
            displayValue: 'Quotes',
            filters: [this.quoteStatusFilter],
        };

        this.renewalFilter = {
            displayKey: policiesMessages.policyLandingRenewal,
            displayValue: 'Renewal',
            filters: [this.renewalStatusFilter],
        };

        this.policyChangeFilter = {
            displayKey: policiesMessages.policyLandingChange,
            displayValue: 'Change',
            filters: [this.policyChangeStatusFilter],
        };

        this.cancellationFilter = {
            displayKey: policiesMessages.policyLandingCancellation,
            displayValue: 'Cancellation',
            filters: [this.cancellationStatusFilter],
        };

        this.customFilters = [
            this.policyFilter,
            this.quoteFilter,
            this.renewalFilter,
            this.policyChangeFilter,
            this.cancellationFilter,
        ];
    }

    createPolicyStatusFilter = status => {
        if (
            _.filter(this.policyStatusFilter.options, {
                code: status,
            }).length === 0
        ) {
            const newFilter = {
                code: status,
                displayKey: status,
                displayValue: status,
                selected: true,
            };
            this.policyStatusFilter.options.push(newFilter);
        }
    };

    createPolicyLineFilter = policyLine => {
        if (
            _.filter(this.policyLinesFilter.options, {
                code: policyLine,
            }).length === 0
        ) {
            const newFilter = {
                code: policyLine,
                displayKey: this.translator({id: this.policyLineCode.getCode(policyLine).name}),
                displayValue: this.translator({id: this.policyLineCode.getCode(policyLine).name}),
                selected: true,
            };
            this.policyLinesFilter.options.push(newFilter);
        }
    };

    getCountInformation = type => {
        return this.policyCountInformation[type];
    };

    getPolicySummaries = (statusCodes, selectedQuickFilter) => {
        statusCodes?.forEach(this.createPolicyStatusFilter);
        this.customFilterForPolicy(selectedQuickFilter);
        return [this.customFilters, this.customLobFilter];
    };

    customFilterForPolicy = (selectedQuickFilter, policiesDetails) => {
        if (selectedQuickFilter === 'delinquentTile') {
            const filterIndex = _.findIndex(this.billingStatusFilter.options, {
                code: 'inGoodStanding',
            });
            _.set(
                this.billingStatusFilter.options[filterIndex],
                'selected',
                false
            );
        }
    };

    populateJobFilterOptions = (filter, statusCodes) => {
        statusCodes?.forEach(statusCode => {
            if (
                !_.find(filter.options, {
                    code: statusCode,
                })
            ) {
                const newFilter = {
                    code: statusCode,
                    displayKey: this.translator({id: this.periodStatusCode.getCode(statusCode).name}),
                    displayValue: this.translator({id: this.periodStatusCode.getCode(statusCode).name}),
                    selected: true,
                };
                filter.options.push(newFilter);
            }
        });
    };

    initJobs = (count, jobTypes, policyLobs) => {
        if (count) {
            this.policyCountInformation.Quotes = count.openSubmissions;
            this.policyCountInformation.Renewal = count.openRenewals;
            this.policyCountInformation.Change = count.openPolicyChanges;
            this.policyCountInformation.Cancellation = count.openCancellations;
            if (count.issuedAndDelinquent) {
                this.policyCountInformation.Policies = count.issuedAndDelinquent;
            } else if (count.delinquentCount != null && count.recentlyIssuedCount != null) {
                const policyCount = count.delinquentCount + count.recentlyIssuedCount;
                this.policyCountInformation.Policies = policyCount;
            }
        }
        policyLobs?.forEach(lob => {
            this.createPolicyLineFilter(lob);
        });
        this.populateJobFilterOptions(this.quoteStatusFilter, jobTypes.submissionTypes);
        this.populateJobFilterOptions(this.renewalStatusFilter, jobTypes.renewalTypes);
        this.populateJobFilterOptions(this.cancellationStatusFilter, jobTypes.cancellationTypes);
        this.populateJobFilterOptions(this.policyChangeStatusFilter, jobTypes.policyChangeTypes);
    };

    mapSelectedStatusCodes = filter => {
        return filter?.options?.filter(opt => opt.selected)?.map(opt => opt.code);
    };

    getStatusCodesForCurrentJobFilter = category => {
        switch(category) {
            case 'Quotes':
                return this.mapSelectedStatusCodes(this.quoteStatusFilter);
            case 'Renewal':
                return this.mapSelectedStatusCodes(this.renewalStatusFilter);
            case 'Change':
                return this.mapSelectedStatusCodes(this.policyChangeStatusFilter);
            case 'Cancellation':
                return this.mapSelectedStatusCodes(this.cancellationStatusFilter);
            case 'Policies':
                const lookup = 'twia-tfpa.gateway.views.policy-landing.Status';
                const filter = this.policyFilter.filters?.find(f => f?.displayKey?.id == lookup);
                return this.mapSelectedStatusCodes(filter);
            default:
                return [];
        }
    };

    getBillingStatusCodesFilter = () => {
        return this.mapSelectedStatusCodes(this.billingStatusFilter)
    };

    getLobCodesFilter = () => {
        return this.mapSelectedStatusCodes(this.policyLinesFilter)
    };

}
